import { ArrowForward, DeleteForever } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
// import PropTypes from 'prop-types';
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CircularProgressWithLabel } from '../../../Components/shared/MuiSharedElements';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import useCraRdv from '../../../hooks/useCraRdv';
import useGetRequest from '../../../hooks/useGetRequest';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import {getNomPrenomClearFromPersoData, isHttpStatusSuccess } from '../../../Utils/utils';

const AoDrafts = () => {

    const { setSelectedAO } = useCraRdv();
    const navigate = useNavigate();
    const { postData } = usePostRequest();
    const {data: AoDrafts, refresh} = useGetRequest({url: '/ao/getAllMyNonCompletedAO',propertyName: 'AoDrafts'});
    const {data: myLastNonCompletedAO} = useGetRequest({url: '/ao/getMyLastNonCompletedAO',propertyName: 'lastNonCompletedAO'});
    const [arrayDrafts,setArrayDrafts]=useState();
    const [selectedAOs,setSelectedAOs]=useState([]);
    const { i18n } = useTranslation();
    const role=useRole();
    useEffect(() => {
        if (AoDrafts) {
            let Array1 = [];
            AoDrafts?.forEach(ao => {
                Array1.push({
                    'aoId': ao?.aoId,
                    'referenceInterne': ao?.referenceInterne,
                    'intitulePoste':ao?.intitulePoste,
                    'statutAo':ao?.statutAo,
                    'nbRecrutes':ao?.nbRecrutes,
                    'dateDebutMission':ao?.dateDebutMission,
                    'dateFinMission':ao?.dateFinMission,
                    'budgetMax': ao?.tjMax ? ao?.tjMax+ ' €' :'Non précisé',
                    'creePar': ao?.collaboratorId?.persoData
                        ? getNomPrenomClearFromPersoData(ao?.collaboratorId?.persoData)
                        : ao?.collaboratorEsnId?.persoData
                            ? getNomPrenomClearFromPersoData(ao?.collaboratorEsnId?.persoData)
                            : 'Back Office',
                    'dateDebutAO':ao?.dateDebutAO,
                    'dateFinAO':ao?.dateFinAO,
                    'createdAt':ao?.createdAt,
                    'progress': ao?.creationStep + '/' + 3,
                    ...ao,
                });
            });
            setArrayDrafts(Array1);
            console.log(Array1,arrayDrafts);
        }
    }, [AoDrafts]);

    const redirectToAoCreation = ({creationStep: creationStep,role, rowData: rowData}) => {
        console.log({FromDrafts: rowData});
        if(role){
            setSelectedAO(rowData);
            // * cad on est sur la deuxieme, "on a cree l'etape 1"
            if(creationStep == 1){
                navigate(`/${role}/createAO/next`, );
            }
            // * cad on est sur la troisieme, "on a cree l'etape 2"
            else if(creationStep == 2){
                navigate(`/${role}/createAO/last`);
            }
        }
    };
    const columns =[
        {
            field: 'aoId',
            title: i18n.t('Réf. AO'),
        },
        {
            field: 'progress',
            title: i18n.t('progrès'),
            render:  rowData => {
                console.log({progress: rowData});
                return (
                    <CircularProgressWithLabel value={(rowData?.creationStep / 3) * 100} />
                );}
        },
        {
            field: 'referenceInterne',
            title: i18n.t('Code int.Client'),
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé'),
        },
        {
            field: 'nbRecrutes',
            title: i18n.t('Nb. de recrutement'),
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début(Mission)'),
            render:  rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>
            )
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin estimée (Mission)'),
            render:  rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateFinMission)}
                </>
            )
        },
        {
            field: 'budgetMax',
            title: i18n.t('Budget Max/j'),
        },
        {
            field: 'creePar',
            title: i18n.t('AO Créé par'),
        },
        {
            field: 'dateDebutAO',
            title: i18n.t('Début publication'),
            render:  rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>
            )
        },
        {
            field: 'dateFinAO',
            title: i18n.t('Fin publication'),
            render:  rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.dateDebutMission)}
                </>
            )
        },
        {
            field: 'createdAt',
            title: i18n.t('Date création'),
            render:  rowData => (
                <>
                    {formatDateJJMMYYYY(rowData?.createdAt)}
                </>
            )
        },
        // {
        //     // field: 'delete',
        //     title: i18n.t('delete',
        //     render:  rowData =>
        //         <DeleteAOComponent rowData={rowData} />
        // },
    ];

    const handleDeleteAO = async () => {
        const aoIds = selectedAOs.map((ao) => ao._id);
        const response1 = await postData({ url: '/ao/deleteAO' , payload: {
            aoIds
        } });
        console.log(response1);
        if(isHttpStatusSuccess(response1.responseStatus)){
            refresh();
        }
    };
    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <div
            className='Frame1AllAOs'
        >
            <div className='frame5Profile'>{role=='esn' ? i18n.t('Mes appels d\'offres'):i18n.t('Appels d\'offres')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Les drafts')} </span> </div>
            <div className='Frame2AllAOs'>
                <h4 className='titlesociete'>
                    {i18n.t('Appels d\'offres en Brouillon')}
                </h4>
            </div>

            {myLastNonCompletedAO &&
                <Alert severity="info">{i18n.t('Vous pouvez reprendre directement depuis le dernier AO non complété intitulé :')} <b>{myLastNonCompletedAO?.intitulePoste}</b>
                    <IconButton
                        contained
                        sx={{ color: '#272D3C' ,padding:'0px'}}
                        onClick={()=>
                            redirectToAoCreation({creationStep: myLastNonCompletedAO?.creationStep,role, rowData: myLastNonCompletedAO})
                        }
                    >
                        <ArrowForward />
                    </IconButton>
                </Alert>
            }
            {selectedAOs.length >0 && <IconButton  onClick={handleDeleteAO}>
                {i18n.t('Delete draft')} <DeleteForever />
            </IconButton>}

            <MaterialTableComponent
                columns={columns}
                data={arrayDrafts}
                options={{
                    selection: true
                }}
                onRowClick={(event, rowData) => {
                    setSelectedRow(rowData?.tableData.id);
                    console.log(rowData);
                    redirectToAoCreation({creationStep: rowData?.creationStep, rowData: rowData});
                }}
                selectedRow={selectedRow}
                onSelectionChange={(rows) => {
                    console.log({rows});
                    setSelectedAOs(rows);
                }}
            />
            {/*<div className='Frame4AllAOs'>
            <div>
                <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                        icons={tableIcons}
                        columns={columns}
                        data={arrayDrafts}
                        onRowClick={(event, rowData) => {
                            console.log(rowData);
                            redirectToAoCreation({creationStep: rowData?.creationStep, rowData: rowData});
                        }}
                        onSelectionChange={(rows) => {
                            console.log({rows});
                            setSelectedAOs(rows);
                        }}
                    />
                </ThemeProvider>
            </div>
        </div>*/}
        </div>

    );
};

export default AoDrafts;